import { PhoneOptionData } from '@/@types/json/hikari';

export class Option {
  public key: string;
  public id: string;
  public name: string;
  public label: string;
  public monthlyCharge: number;

  constructor(id: string, key: string, data: PhoneOptionData) {
    this.key = key;
    this.id = id;
    this.name = data.名前;
    this.label = data.ラベル;
    this.monthlyCharge = data.月額費用;
  }
}
